import { createSlice } from '@reduxjs/toolkit';

export const name = 'channelFacet';
const initialState: ChannelFacetState = {
	id: null,
	name: null,
	territory: null,
	type: null,
	highlights: false,
	page: 0,
	count: 0
};

export const channelFacetSlice = createSlice({
	name,
	initialState,
	reducers: {
		setIdFacet: (state, { payload }): void => {
			state.id = payload;
			state.page = initialState.page;
			state.count = initialState.count;
		},
		setNameFacet: (state, { payload }): void => {
			state.name = payload;
			state.page = initialState.page;
			state.count = initialState.count;
		},
		setTerritoryFacet: (state, { payload }): void => {
			state.territory = payload;
			state.page = initialState.page;
			state.count = initialState.count;
		},
		setTypeFacet: (state, { payload }): void => {
			state.type = payload;
			state.page = initialState.page;
			state.count = initialState.count;
		},
		toggleHighlightsFacet: (state): void => {
			state.highlights = !state.highlights;
			state.page = initialState.page;
			state.count = initialState.count;
		},
		setPage: (state, { payload }): void => {
			state.page = payload;
		},
		setCount: (state, { payload }): void => {
			state.count = payload;
		},
		resetAllFacets: (state): void => {
			state.id = initialState.id;
			state.name = initialState.name;
			state.territory = initialState.territory;
			state.type = initialState.type;
			state.highlights = initialState.highlights;
			state.page = initialState.page;
			state.count = initialState.count;
		}
	}
});

export const { setIdFacet, setNameFacet, setTerritoryFacet, setTypeFacet, toggleHighlightsFacet, setPage, setCount, resetAllFacets } =
	channelFacetSlice.actions;

export default channelFacetSlice.reducer;

export interface ChannelFacetState {
	id: string | null;
	name: string | null;
	territory: string | null;
	type: string | null;
	highlights: boolean;
	page: number;
	count: number;
}
